<template>

    <div class="users-style">
        <!-- Abdullah added this code here  -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Downloads<span>

                <!-- AbdullahALC chnaged pageurl to api url -->
                <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Downloads</span>
        </h4>

        <div class="row no-margin mt-4"> <!-- Abdullah added this code here  -->
            <div class="ibox col-md-12 px-4"> <!-- Abdullah added this code here  -->
                <!-- <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert> -->
                <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>
                <div class="ibox-title dashboard_title px-0"> <!-- Abdullah added this code here  -->
                    <h4>Downloads</h4>
                </div>

                <div class="ibox-content px-0 pt-4 employee-table-wrapper"> <!-- Abdullah added this code here  -->
                    <div class="row no-gutters py-2 mb-3 pl-0 "> <!-- Abdullah added this code here  -->
                        <div class="col-sm-6">
                            <div class="custom-search">
                                <b-input-group class="mb-0">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search Downloads..." v-model="search"
                                        @input="resetPagination()"></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                    </div>

                    <b-overlay :show="showoverlay" rounded="sm">
                        <div class='employee-table-wrapper table-sticky-height'>
                            <table class="table dataTable text-center">
                                <thead class='text-center'>
                                    <tr class="table-head">
                                        <td>#SL</td>
                                        <td>Type</td>
                                        <td>Month - Year</td>
                                        <td>Download Status</td>
                                        <td>Estimated Download Processing Time</td>
                                        <td class='action-td'>Download</td>
                                        <td>Time of Download Expiry</td>
                                        <td>Download Requested By</td>
                                        <td>Download Frequency</td>
                                        <td>Action</td>
                                        <!-- <td class="float-right">Action</td> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="hover-bg table-row border-bottom mx-2"
                                        v-for="(schedule, n) in paginatedData" :key="schedule.id">
                                        <td class="align-middle list-columns text-center">{{ schedule.sl }}</td>
                                        <td class=" align-middle list-columns text-center"><template
                                                v-if="schedule.function == 'Taxcadrs'">Tax Cards</template><template
                                                v-if="schedule.function == 'Payslips'">Pay Slips</template></td>
                                        <td class="align-middle list-columns text-center">{{ schedule.month_year }}</td>

                                        <!-- Abdullah 17-05-26 commented this  -->
                                        <!-- <td :class="[{ 'color-red' : (schedule.status > 1 && schedule.status != 4) }, tableStickyHeight]">{{ status[schedule.status].text }}</td> -->
                                        <!-- Abdullah 17-05-26 added this  -->
                                        <td
                                            :class="[tableStickyHeight, { 'color-red': (schedule.status > 1 && schedule.status != 4), 'color-green': schedule.status == 1 }]">
                                            {{ status[schedule.status].text }}
                                        </td>
                                        <!-- Abdullah 17-05-26 added this upto this  -->

                                        <td class="align-middle list-columns text-center">
                                            <template v-if="schedule.status != 2">
                                                <template v-if="schedule.generated_at == '0000-00-00 00:00:00'">{{
                                                    get_estimated_time_individual(schedule.requested_at) }}</template>
                                                <template v-else>{{ time_format(schedule.generated_at) }}</template>
                                            </template>
                                            <template v-else>
                                                Not Available
                                            </template>
                                        </td>
                                        <td class="align-middle list-columns text-center action-td">
                                            <template v-if="schedule.status == 0 || schedule.status == 2">
                                                Not Available
                                            </template>
                                            <template v-if="schedule.status == 3">
                                                Download Expired
                                            </template>
                                            <template v-if="schedule.status == 1">
                                                <!-- <a class="cursor-pointer" @click="executeFile(schedule.id , 0,schedule.function)"><img src="https://secure.accordhrm.com/images/zipp.png" class="mr-2" width="20px">Download</a> -->
                                                <!-- Abdullah 17-05-26 chnaged imahe linek and width  -->
                                                <a class="cursor-pointer"
                                                    @click="executeFile(schedule.id, 0, schedule.function)"><img
                                                        src="https://secure.accordhrm.com/images/download_image.png"
                                                        class="mr-2" width="70px"></a>
                                            </template>
                                        </td>
                                        <td class="align-middle list-columns text-center">
                                            <template v-if="schedule.status != 2">
                                                <template v-if="schedule.status == 0"></template>
                                                <template v-else>{{ time_format_expire(schedule.generated_at)
                                                }}</template>
                                            </template>
                                            <template v-else>
                                                N/A
                                            </template>
                                        </td>
                                        <td class="align-middle list-columns text-center" v-html='schedule.request_by'>
                                        </td>
                                        <td class="align-middle list-columns text-center">{{ schedule.no_download }}
                                        </td>
                                        <template v-if="schedule.status == 0">
                                            <td class="align-middle list-columns text-center ">

                                                <div class="col-sm-2 py-1 pl-0 pr-3 float-right">
                                                    <a id="actionDropdown"
                                                        class="dropdown-toggle clearfix action-dropdown-toggle"
                                                        style="font-size: 16px;" href="#" role="button"
                                                        data-toggle="dropdown" aria-haspopup="true"
                                                        aria-expanded="false"><b-icon
                                                            icon="three-dots-vertical"></b-icon></a>
                                                    <div class="dropdown-menu action-dropdown-menu"
                                                        aria-labelledby="actionDropdown">
                                                        <b-button-group>
                                                            <b-button variant="outline-secondary"
                                                                class="d-flex align-items-start request-remove-btn"
                                                                @click="deleteFile(schedule.id)">
                                                                <b-icon icon="x" class="mr-2 mt-1"></b-icon>
                                                                <span>Request Remove</span>
                                                            </b-button>
                                                        </b-button-group>
                                                    </div>
                                                </div>
                                            </td>
                                        </template>
                                        <template v-else>
                                            <td class="align-middle list-columns  text-center"
                                                v-html='schedule.remove_by'></td>
                                        </template>
                                    </tr>
                                </tbody>
                            </table>

                            <!-- alpha fix- this pagination  -->
                            <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!
                            </div>
                            <div v-else class="row py-2 no-margin"> <!-- Abdullah chnaged class. was class="px-3-->
                                <div class="col-md-12 p-0 no-margin"><!-- Abdullah added this div-->
                                    <ul class="pagination b-pagination float-left mb-0 mt-1">
                                        <li class="page-item disabled m-2">View</li>
                                        <li class="page-item disabled"><b-form-select v-model="temp_length"
                                                :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                        <li class="page-item disabled m-2">per page. Total {{ people }} records found.
                                        </li>
                                    </ul>
                                    <b-pagination-nav v-model="pagination.currentPage"
                                        :number-of-pages="pagination.pages" base-url="#" first-number
                                        last-number><template #prev-text><span>Previous</span></template><template
                                            #next-text><span>Next</span></template></b-pagination-nav>
                                </div>
                            </div>
                        </div>

                        <!-- alpha fix- commented this pagination  -->
                        <!-- <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Download Request
                            Found!</div>
                        <div v-else class="px-3"><b-pagination-nav v-model="pagination.currentPage"
                                :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next"
                                first-number last-number></b-pagination-nav></div> -->
                    </b-overlay>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
export default {

    mounted() {

    },
    data() {
        return {
            schedules: [],
            showoverlay: false,

            status: [
                { value: "0", text: "Queued for Processing " },
                { value: "1", text: "Ready for Download " },
                { value: "2", text: "Request Removed " },
                { value: "3", text: "File Removed by System" },
                { value: "4", text: "Processing" },
                { value: "5", text: "Process stopped. Please contact with Adminstrator" },
            ],
            types: { 'downloadpayslips': 'Payslips', 'downloadtaxcards': 'Taxcards' },
            search: '',
            tableStickyHeight: "align-middle list-columns text-center",
            ce: true,
            estimated_time: '',
            res: true,
            successmsg: false,

            // alpha fix- added this for pagination  */
            length: 20,
            temp_length: 20,
            people: 0,
            length_options: [
                { value: 20, text: "20" },
                { value: 50, text: "50" },
                { value: 100, text: "100" }
            ],
            pagination: { currentPage: 1, pages: 1 },
        }
    },
    methods: {


        getSchedulData: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/schedule/list', {
                params: {

                }
            }).then(function (response) {
                this.schedules = response.data;
                // / alpha fix- added this for pagination  */
                this.people = response.data.length;

            }.bind(this)).catch(function (error) {
                //currentObj.serverError(error);
            });
        },
        time_format: function (data) {
            var ready_date = new Date(data);

            ready_date.setHours(ready_date.getHours());

            var month = ready_date.toLocaleString('default', { month: 'long' });
            var date = ready_date.getDate();
            var year = ready_date.getFullYear();
            var time = ready_date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
            var all = time + ' BST, ' + date + ' ' + ' ' + month + ' ' + year;

            return all;
        },
        time_format_expire: function (data) {
            if (data == '0000-00-00 00:00:00') {
                return '';
            }
            var ready_date = new Date(data);
            ready_date.setHours(ready_date.getHours());
            ready_date.setDate(ready_date.getDate() + 10);
            var month = ready_date.toLocaleString('default', { month: 'long' });
            var date = ready_date.getDate();
            var year = ready_date.getFullYear();
            var time = ready_date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
            var all = time + ' BST, ' + date + ' ' + ' ' + month + ' ' + year;
            return all;
        },
        get_estimated_time_individual: function (times) {
            var now = new Date(times);
            var real_now = new Date();

            // if(real_now > now)
            // {
            //     now = real_now;
            // }

            var time = "1:00 PM";
            var dt = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + time;
            var userval = new Date(dt);


            if (now > userval) //do logic
            {
                now.setDate(now.getDate() + 1);
                var month = now.toLocaleString('default', { month: 'long' });
                var date = now.getDate();
                var year = now.getFullYear();


            }
            else {
                var month = userval.toLocaleString('default', { month: 'long' });
                var date = userval.getDate();
                var year = userval.getFullYear();

            }



            var n_time = time + ' BST, ' + date + ' ' + ' ' + month + ' ' + year + ' (Estimated)';

            return n_time;
        },



        get_estimated_time: function () {
            var now = new Date();
            var time = "1:00 PM";
            var dt = (now.getMonth() + 1) + "/" + now.getDate() + "/" + now.getFullYear() + " " + time;

            var userval = new Date(dt);
            if (now > userval) //do logic
            {
                now.setDate(now.getDate() + 1);
                var month = now.toLocaleString('default', { month: 'long' });
                var date = now.getDate();
                var year = now.getFullYear();

                this.estimated_time = time + ' BST, ' + date + ' ' + ' ' + month + ' ' + year + ' (Estimated)';
            }
            else {
                var month = userval.toLocaleString('default', { month: 'long' });
                var date = userval.getDate();
                var year = userval.getFullYear();

                this.estimated_time = time + ' BST, ' + date + ' ' + ' ' + month + ' ' + year + ' (Estimated)';
            }
        },
        deleteFile: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm that you want to remove this request.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            }).then(value => {
                if (value)
                    this.executeFile(x, 1)
            })
                .catch(err => {
                    // An error occurred
                })



        },
        executeFile: function (x, f, function_name = '') {
            let currentObj = this;
            let formData = new FormData();
            formData.append('id', x);
            formData.append('flag', f);

            axios.post(this.$api_url + '/schedule/file', formData).then(function (response) {

                if (f == 0) {
                    var fname = response.data.file_name;
                    if (response.data.download_file_name)
                        var download_f_name = response.data.download_file_name;
                    else
                        var download_f_name = fname;
                    console.log(function_name);

                    if (function_name == 'Payslips') {
                        window.location.href = this.$api_url + '/downloadzippayslip?file_name=' + fname + '&download_file_name=' + download_f_name;
                    }

                    else if (function_name == 'Taxcadrs') {
                        window.location.href = this.$api_url + '/downloadziptaxcard?file_name=' + fname + '&download_file_name=' + download_f_name;
                    }
                    else if (function_name == 'PF Slips') {
                        window.location.href = this.$api_url + '/downloadzippfslip?file_name=' + fname + '&download_file_name=' + download_f_name;
                    }

                    //this.trzdownload(response.data.file_url , response.data.download_name);
                }
                else
                    this.$bvToast.toast('Deleted!', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });

                this.getSchedulData();

            }.bind(this)).catch(function (error) {
                currentObj.serverError(error);
                currentObj.errormsg = error.response.data.errors;
            });

        },
        trzdownload: function (url, filename) {
            fetch(url).then(function (t) {
                return t.blob().then((b) => {
                    var a = document.createElement("a");
                    a.href = URL.createObjectURL(b);
                    a.setAttribute("download", filename);
                    a.click();
                }
                );
            });
        }

    },
    created: function () {
        this.get_estimated_time();
        this.getSchedulData();
        Fire.$on('reloadUsers', () => { this.getSchedulData() });
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.schedules;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });
            }
            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>

<style scoped>
.btn.btn-primary {
    padding: 6px;
}

.btn.btn-primary.btn-full-width {
    font-size: 10px;
}

.action-td {
    width: 135px;
}

.color-red {
    color: #e3342f;
}

/* Abdullah 17-05-26 added this  */
.color-green {
    color: #126D66 !important;
}
</style>
